import { Routes, Route, Navigate, Outlet, useOutletContext } from 'react-router-dom'
import React from 'react'
import Hero from './components/Hero'
import SEO from './components/SEO'
import PageLayout from './components/PageLayout'
import { usePageTracking } from './hooks/usePageTracking'
import './index.css'
import './i18n'

// Lazy load pages
const Benchmark = React.lazy(() => import('./pages/Benchmark'));
const Privacy = React.lazy(() => import('./pages/Privacy'));
const Terms = React.lazy(() => import('./pages/Terms'));
const Company = React.lazy(() => import('./pages/Company'));
const Download = React.lazy(() => import('./pages/Download'));
const AppsCatalog = React.lazy(() => import('./pages/AppsCatalog'));
const AppDetail = React.lazy(() => import('./pages/AppDetail'));
const ToolsCatalog = React.lazy(() => import('./pages/ToolsCatalog'));
const ToolDetail = React.lazy(() => import('./pages/ToolDetail'));
const Changelog = React.lazy(() => import('./pages/Changelog'));

// Lazy load components below the fold for better initial load
const FeatureShowcase = React.lazy(() => import('./components/FeatureShowcase'));
const FAQ = React.lazy(() => import('./components/FAQ'));

const Home = ({ onDownloadClick }) => {
  return (
    <div className="page-transition">
      <SEO />
      <Hero onDownloadClick={onDownloadClick} />
      <React.Suspense fallback={<div style={{ minHeight: '400px' }} />}>
        <FeatureShowcase />
        <FAQ onEmailCapture={onDownloadClick} />
      </React.Suspense>
    </div>
  )
}

const HomeWrap = () => {
  const { onDownloadClick } = useOutletContext();
  return <Home onDownloadClick={onDownloadClick} />;
}

const RootRedirect = () => {
  const browserLang = navigator.language.split('-')[0]
  const targetLang = browserLang === 'es' ? 'es' : 'en'
  return <Navigate to={`/${targetLang}`} replace />
}

function App() {
  // Track page views on route changes
  usePageTracking();
  
  return (
    <Routes>
      <Route path="/:lang" element={<PageLayout />}>
        <Route index element={<HomeWrap />} />
        <Route path="benchmark" element={
          <React.Suspense fallback={<div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div className="text-gradient" style={{ fontSize: '2rem' }}>Loading...</div></div>}>
            <Benchmark />
          </React.Suspense>
        } />
        <Route path="privacy" element={
          <React.Suspense fallback={null}>
            <Privacy />
          </React.Suspense>
        } />
        <Route path="terms" element={
          <React.Suspense fallback={null}>
            <Terms />
          </React.Suspense>
        } />
        <Route path="company" element={
          <React.Suspense fallback={null}>
            <Company />
          </React.Suspense>
        } />
        <Route path="download" element={
          <React.Suspense fallback={null}>
            <Download />
          </React.Suspense>
        } />
        <Route path="apps" element={
          <React.Suspense fallback={null}>
            <AppsCatalog />
          </React.Suspense>
        } />
        <Route path="apps/:appId" element={
          <React.Suspense fallback={null}>
            <AppDetail />
          </React.Suspense>
        } />
        <Route path="tools" element={
          <React.Suspense fallback={null}>
            <ToolsCatalog />
          </React.Suspense>
        } />
        <Route path="tools/:toolId" element={
          <React.Suspense fallback={null}>
            <ToolDetail />
          </React.Suspense>
        } />
        <Route path="changelog" element={
          <React.Suspense fallback={null}>
            <Changelog />
          </React.Suspense>
        } />
      </Route>
      <Route path="/" element={<RootRedirect />} />
      <Route path="*" element={<Navigate to="/en" replace />} />
    </Routes>
  )
}

export default App

